export default __webpack_public_path__ + "static/media/toowarm.cc194160.jpeg";